module.exports = __webpack_public_path__ + "static/media/edit2.5fea4317.svg";